import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircle1,
  faCircle2,
  faCircle3,
  faCalendarDay
} from '@fortawesome/pro-light-svg-icons';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const Card = styled.div`
  max-width: 296px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: ${SPACERS.small};
  .stageIcon {
    width: 32px;
    height: 32px;
  }
  .dateIcon {
    width: 16px;
    height: 16px;
  }
  .date {
    margin-bottom: ${SPACERS.small};
  }
`;

const getIcon = (index: number) => {
  switch (index) {
    case 0:
      return faCircle1;
    case 1:
      return faCircle2;
    default:
      return faCircle3;
  }
};

interface StageCardProps {
  stageName: string;
  stageDate: string;
  stageDesc: string;
  stageTime: string;
  index: number;
}

const StageCard: React.FC<StageCardProps> = ({
  stageName,
  stageDesc,
  stageDate,
  stageTime,
  index
}) => {
  return (
    <Card>
      <FontAwesomeIcon icon={getIcon(index)} className="stageIcon" />
      <div>
        <TrueImpactText variant="heading-subheading">
          The <strong>{stageName}</strong>
        </TrueImpactText>
        <TrueImpactText variant="body" className="date">
          <FontAwesomeIcon icon={faCalendarDay} className="dateIcon" />{' '}
          {stageDate}
        </TrueImpactText>
        <TrueImpactText variant="body">
          {stageDesc} <strong>{stageTime}</strong>
        </TrueImpactText>
      </div>
    </Card>
  );
};

export default StageCard;
